/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type PanelsState = {
  chat: boolean;
  details: boolean;
};

type WidthsState = {
  client: number;
  chat: number;
  details: number;
};

interface ResizerState {
  widths: WidthsState;
  panels: PanelsState;
}

const initialState: ResizerState = {
  widths: {
    client: 400,
    chat: 600,
    details: 400,
  },
  panels: {
    chat: false,
    details: false,
  },
};

const resizerLayoutSlice = createSlice({
  name: 'resizerLayout',
  initialState,
  reducers: {
    setWidths(state: ResizerState, action: PayloadAction<WidthsState>) {
      state.widths = action.payload;
    },
    updateClient(state: ResizerState, action: PayloadAction<number>) {
      state.widths.client = action.payload;
    },
    updateChat(state: ResizerState, action: PayloadAction<number>) {
      state.widths.chat = action.payload;
    },
    updateDetails(state: ResizerState, action: PayloadAction<number>) {
      state.widths.details = action.payload;
    },
    setPanels(state: ResizerState, action: PayloadAction<Partial<PanelsState>>) {
      state.panels = { ...state.panels, ...action.payload };
    },
    resetPanels(state) {
      state.panels = { chat: false, details: false };
    },
  },
});

export const { setWidths, updateClient, updateChat, updateDetails, setPanels, resetPanels } =
  resizerLayoutSlice.actions;

export default resizerLayoutSlice.reducer;
